var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon, Input, InputGroup, InputLeftElement } from 'shared/components/ui';
import { Calendar } from 'shared/assets/icons';
import React from 'react';
export var CalendarIconInput = React.forwardRef(function (forwarded_props, ref) {
    var size = forwarded_props.size, onClick = forwarded_props.onClick, readOnly = forwarded_props.readOnly, props = __rest(forwarded_props, ["size", "onClick", "readOnly"]);
    return (_jsxs(InputGroup, __assign({ onClick: onClick }, { children: [_jsx(InputLeftElement, __assign({ pointerEvents: "none", children: _jsx(Icon, { boxSize: 4, as: Calendar, color: "gray.500" }) }, (readOnly
                ? {
                    width: 0,
                    left: 2.5,
                    height: 'auto',
                }
                : {}))), _jsx(Input, __assign({ variant: "outline", placeholder: "Select", paddingLeft: 5, _focus: { borderColor: 'gray.700' }, _readOnly: {
                    border: 'none',
                    padding: 0,
                    paddingLeft: 8,
                    height: 'auto',
                }, autoFocus: true, ref: ref, readOnly: readOnly }, props))] })));
});
